import EmailIcon from '@mui/icons-material/EmailOutlined'
import SecurityIcon from '@mui/icons-material/Security'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import { Box, Grid2, Typography } from '@mui/material'
import DefaultLayout from 'components/layout/DefaultLayout'
import useStyles from './styles'

export const contact = [
  {
    id: 'email',
    label: 'Email',
    path: 'mailto:support@getgoldie.co.nz',
    icon: <EmailIcon />
  },
  {
    id: 'security',
    label: 'Security',
    path: 'mailto:security@getgoldie.co.nz',
    icon: <SecurityIcon />
  },
  {
    id: 'chat_on_the_phone',
    label: 'Chat on the phone',
    path: 'tel:+6448873779',
    icon: <PhoneAndroidIcon />
  }
]

export default function Contact(): JSX.Element {
  const { classes } = useStyles()
  return (
    <DefaultLayout heading='Contact' showBackIcon showSecondNav={false}>
      <Grid2 container gap={2} className={classes.root}>
        {contact.map(menu => (
          <Grid2 key={menu.id} size={{ xs: 12 }}>
            <Box className={classes.menu} component='a' href={menu.path}>
              <Box>{menu.icon}</Box>
              <Typography>{menu.label}</Typography>
            </Box>
          </Grid2>
        ))}
      </Grid2>
    </DefaultLayout>
  )
}
